import { render, staticRenderFns } from "./requestStat.vue?vue&type=template&id=49c2873c&"
import script from "./requestStat.vue?vue&type=script&lang=js&"
export * from "./requestStat.vue?vue&type=script&lang=js&"
import style0 from "./requestStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports